// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"gj","winCardBox":"gj","win-card-btn-detail":"gk","winCardBtnDetail":"gk","win-card-dec":"gl","winCardDec":"gl","win-card-name":"gm","winCardName":"gm"};